import { Component, Input } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { ImageInfo, UploadComponent } from "../upload/upload.component";
import { UploadModule } from "@progress/kendo-angular-upload";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { NumericTextBoxModule } from "@progress/kendo-angular-inputs";

@Component({
    selector: 'app-dialog',
    imports: [UploadModule, DialogModule, UploadComponent, NumericTextBoxModule],
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements HttpInterceptor {
  @Input() public editor: EditorComponent;

  public opened = false;
  public src: string;
  public height: number;
  public width: number;

  public get canInsert(): boolean {
    return !this.src;
  }

  public uploadImage(): void {
    // Invoking the insertImage command of the Editor.
    this.editor.exec("insertImage", this.imageInfo);

    // Closing the Dialog.
    this.close();
  }

  public get imageInfo(): ImageInfo {
    return {
      src: this.src,
      height: this.height,
      width: this.width,
    };
  }

  public setImageInfo(value: ImageInfo) {
    if (value) {
      this.src = value.src;
      this.height = value.height;
      this.width = value.width;
    } else {
      this.resetData();
    }
  }

  public open(): void {
    this.opened = true;
  }

  public close(): void {
    this.opened = false;
    this.resetData();
  }

  public resetData(): void {
    //this.src = null;
    //this.width = null;
    //this.height = null;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable < HttpEvent < any >> {
    if(req.url === "saveUrl" || req.url === "removeUrl") {
    return of(new HttpResponse({ status: 200 }));
  }

  return next.handle(req);
}
}
